var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Icon from "./icon.svg";
var Native = Icon;
var Web = function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 141.73 141.73" }),
    React.createElement("g", { id: "Capa_2", "data-name": "Capa 2" },
        React.createElement("g", { id: "Capa_1-2", "data-name": "Capa 1" },
            React.createElement("rect", { width: "141.73", height: "141.73", rx: "34.98", stroke: "transparent" }),
            React.createElement("path", { d: "M70.86,87.77a5.83,5.83,0,0,0,0,11.65,5.83,5.83,0,0,0,0-11.65Z", fill: "#fff" }),
            React.createElement("path", { d: "M124.8,108.42a19.91,19.91,0,0,0,0-20.14L88.35,25.07a20.11,20.11,0,0,0-34.92,0L16.88,88.33a20.19,20.19,0,0,0,17.48,30.25h72.91A20.07,20.07,0,0,0,124.8,108.42Zm-7.92-4.57a11,11,0,0,1-9.63,5.57H34.34A10.88,10.88,0,0,1,24.83,104a11,11,0,0,1,0-11.12L61.35,29.59a11,11,0,0,1,19.07,0L117,92.87A10.92,10.92,0,0,1,116.88,103.85Z", fill: "#fff" }),
            React.createElement("path", { d: "M69.42,46.86a6.34,6.34,0,0,0-4.5,6.37c.14,1.84.26,3.7.4,5.54.39,7,.79,13.89,1.19,20.91a4.26,4.26,0,0,0,4.35,4.1,4.35,4.35,0,0,0,4.36-4.24c0-1.44,0-2.77.14-4.24.26-4.5.54-9,.8-13.5.14-2.91.39-5.82.53-8.74a7.27,7.27,0,0,0-.53-2.91A5.86,5.86,0,0,0,69.42,46.86Z", fill: "#fff" }))))); };
export default { Native: Native, Web: Web };
